import { baseUrl, handleResponse, handleError, GetHeaders } from "../../../../apis/common/ApiUtils";

const empSearchUrl = baseUrl + "common/empsearch";

// Function for admin employee list
export function getAdminEmployeeList(includeTerminated = false) {
    const url = includeTerminated
        ? `${empSearchUrl}/list/admin?includeTerminated=true`
        : `${empSearchUrl}/list/admin`;
    return fetch(url, GetHeaders()).then(handleResponse).catch(handleError);
}

// Function for manager employee list
export function getManagerEmployeeList() {
    return fetch(`${empSearchUrl}/list/manager`, GetHeaders()).then(handleResponse).catch(handleError);
}